import {
  BasicInfoBeneficiary,
  TermsBeneficiary,
  EvaluationFormBeneficiary,
  DocumentsBeneficiary,
  } from './components';
  import { getLocalString, localNames } from "utils/localisation.service";
  import locale from 'antd/lib/date-picker/locale/el_GR';
import { tabs } from './components/basicInfoBeneficiary/tabs';

export const stepsBeneficiary = [
    {
      name: 'BASICFORM',
      label: 'Βασικά Στοιχεία',
      Component: BasicInfoBeneficiary,
      id: 0,
      subtabs: true,
      tabsComponent : tabs()
    },
    {
      name: 'DOCUMENTS',
      label: 'Έγγραφα',
      Component: DocumentsBeneficiary,
      id: 1,
    },
    {
      name: 'TERMS',
      label: 'Όροι και Προϋποθέσεις',
      Component: TermsBeneficiary,
      id: 2,
    },
  ];